import React from 'react'
import { observer } from 'mobx-react'

import Autosuggest from 'components/autosuggest/Autosuggest'
import { IProps as ITableCellEditorParams } from './TableCellEditor'

import styles from './booleanInput.scss'

interface IProps extends ITableCellEditorParams {
  initialValue: string | null
}

interface IState {
  value: string | null
}

class EnumInput extends React.PureComponent<IProps, IState> {
  private input: React.RefObject<any> = React.createRef()

  constructor(props: IProps) {
    super(props)

    this.state = {
      value: props.initialValue ?? null,
    }
  }

  // Called by ag-grid to get the final value when editing is finished
  getValue = () => this.state.value

  focus = () => {
    this.input.current?.focus()
  }

  handleChange = (value: string) => {
    this.setState({ value })
  }

  handleSubmit = (value: string) => {
    this.setState({ value }, () => {
      this.props.stopEditing()
    })
  }

  render() {
    const { value } = this.state
    const { field } = this.props

    return (
      <Autosuggest
        ref={this.input}
        dataCy="input--enum"
        className={styles.input}
        value={value === null || value === undefined ? '' : String(value)}
        suggestions={field.typeAsEnum!.values}
        onChange={this.handleChange}
        onSubmit={this.handleSubmit}
      />
    )
  }
}

export default observer(EnumInput)
